module.exports = __webpack_public_path__ + "static/media/Image0.0861c05e.png";